<div class="m-4 p-4 border border-neutral-400 rounded space-y-4" id="welcome-view">
  <h4 class="title-2 text-secondary-400">Welcome to Carelon Medical Benefits Management Portal!</h4>

  @if (isReferralDashboardHidden) {
    <div>
      <p class="font-semibold marker:text-secondary-400 mb-4">Please navigate to the Referral Dashboard for the following programs:</p>
      <ul class="list-disc pl-6 mb-4">
        @if (isWCCExternal) {
          <li>Wound Care Connect</li>
        }
        @if (isSDoHorReferralProgramAdmin) {
          <li>SDoH</li>
        }
      </ul>
      <button
        pButton
        type="button"
        label="Referral Dashboard"
        icon="pi pi-external-link"
        (click)="openReferralDashboard()"
      ></button>
    </div>
  }
</div>
